import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
  footer?: ReactNode;
  hoverable?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  noBorder?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, header, footer, hoverable = false, padding = 'md', noBorder = false, className = '', ...props }, ref) => {
    const baseClasses = 'rounded-2xl bg-dark-card backdrop-blur-md border border-white/5 shadow-card';
    const borderClasses = noBorder ? '!border-0' : '';
    const hoverClasses = hoverable ? 'transition-all duration-300 hover:border-accent/30 hover:shadow-glow cursor-pointer' : '';
    const paddingClasses = { none: '', sm: 'p-3', md: 'p-5', lg: 'p-8' };

    return (
      <div ref={ref} className={`${baseClasses} ${borderClasses} ${hoverClasses} ${className}`} {...props}>
        {header && <div className="px-5 py-4 border-b border-white/5">{header}</div>}
        <div className={paddingClasses[padding]}>{children}</div>
        {footer && <div className="px-5 py-4 border-t border-white/5">{footer}</div>}
      </div>
    );
  }
);

Card.displayName = 'Card';
export default Card;
